import {Brick, CloudObject, Order, Predicate, Query, registerBrick} from 'olympe';
import Request from './Request';
import State from './State';

export default class TestComplexQuery extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */

    async update($, inputs, [forwardEvent]) {
        const user = 'Alice';


        // offsets for each of the query needs to be persisted for later queries
        // get from local context.
        // local context keeps state till it's destroyed (app is closed, change of tab in the app, etc)
        const queriesOffsets = ($.get('queriesOffsetsGetBCPRequests') || '0;0;0').split(';').map(Number);
        const totalOffset = Number($.get('totalOffsetGetBCPRequests')) || 0;
        // example limit, this would typically be a parameter
        const limit = 1;

        // ==== do these 3 queries only if user is not admin, isAdmin should be parameter ====

        // query 1 fetches requests for the requestors criteria
        // need to add sorting based on the status+date (not possible to do both atm, just do status)
        const requestorPred = Predicate.equals(Request.requestorProp, user);
        const query1 = Query.instancesOf(Request).filter(requestorPred).sortBy(Request.date_creationProp, Order.DESC).andReturn().limit(50, queriesOffsets[0]);

        // query 2 fetches request for the BP criteria
        // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        const bpPredicate = Predicate.equals(Request.bpProp, user);
        const bpStatePredicate = Predicate.equals(State.nameProp, 'bp');
        const query2 = Query.instancesOf(Request).filter(bpPredicate).sortBy(Request.date_creationProp, Order.DESC).andReturn().follow(Request.currentStateRel).filter(bpStatePredicate).andReturn().limit(limit, queriesOffsets[1]);

        // query 3 fetches request for the PM criteria
        // adapt query/values/relations to proper state values using constants in BCPWorkflowAuthorizations.
        const pmPredicate = Predicate.equals(Request.pmProp, user);
        const pmStatePredicate = Predicate.equals(State.nameProp, 'pm');
        const query3 = Query.instancesOf(Request).filter(pmPredicate).sortBy(Request.date_creationProp, Order.DESC).andReturn().follow(Request.currentStateRel).filter(pmStatePredicate).andReturn().limit(limit, queriesOffsets[2]);

        try {
            const res1 = (await query1.execute()).toArray();
            // get result & isolate request from workflow state
            const res2 = (await query2.execute()).toArray().map(([request]) => request);
            // get result & isolate request from workflow state
            const res3 = (await query3.execute()).toArray().map(([request]) => request);
            // combine all 3 array while removing duplicates
            // init concat result with res1
            const merged = [];
            const seenTags = new Set();

            // get maximum size for concat results:
            // avoid edge case where we do not have enough results to fill up to "limit" length
            const maxSize = Math.min(limit, res1.length + res2.length + res3.length);
            let cursors = [0, 0, 0];
            while (merged.length < maxSize) {
                const req1 = res1[cursors[0]];
                const req2 = res2[cursors[1]];
                const req3 = res3[cursors[2]];
                const requestsToMerge = [req1, req2, req3]
                const maxDate = Math.max(
                    req1 ? req1.get(Request.date_creationProp).getTime() : -Infinity,
                    req2 ? req2.get(Request.date_creationProp).getTime() : -Infinity,
                    req3 ? req3.get(Request.date_creationProp).getTime() : -Infinity
                );
                // need to check if null!
                const requestIndex = requestsToMerge.findIndex(req => req && req.get(Request.date_creationProp).getTime() === maxDate);

                if (requestIndex !== -1) {
                    const nextRequest = requestsToMerge[requestIndex];
                    if (!seenTags.has(nextRequest.getTag())) {
                        seenTags.add(nextRequest.getTag());
                        merged.push(nextRequest);
                    }
                    // move cursor regardless (ignoring duplicate)
                    cursors[requestIndex]++;
                } else {
                    // all arrays exhausted
                    break;
                }
            }
            const newQueryOffsets = queriesOffsets.map((queryOffset, idx) => queryOffset + cursors[idx]);
            // update offset for pagination in draw:
            $.set('totalOffsetGetBCPRequests', totalOffset + merged.length);
            $.set('queriesOffsetsGetBCPRequests', newQueryOffsets.join(';'));
            // update offset for individual queries
            for (let i = 0; i < queriesOffsets.length; i++) {
                queriesOffsets[i] += cursors[i];
            }
            console.log('Merged: ', merged)
        } catch (e) {
            console.error(e);
        }
        forwardEvent();
    }
}

registerBrick('018b8afbfba49118bc80', TestComplexQuery);
